import { $, insertHTML, remove } from 'utils/dom';

export default class LoadMore {
  constructor(props) {
    this.container = props.container;
    this.ajaxUrl = props.ajaxUrl;
    this.axios = null;
    this.cb = props.cb;
    this.onLoad = props.onLoad;
    this.onFinished = props.onFinished;
  }

  ajaxLoad = () => this.onLoad && this.onLoad();

  ajaxFinished = () => this.onFinished && this.onFinished();

  ajaxCall = (ajaxUrl, ajaxConfig) => {
    this.ajaxLoad();
    this.axios
      .get(ajaxUrl)
      .then(({ data }) => {
        // Parse response string to html.
        const $response = new DOMParser().parseFromString(
          data,
          'text/html'
        ).body;
        // if there is no config (the first pageload ajax request dont have a config),
        // we gonna replace the whole container
        if (ajaxConfig) {
          this.handleConfigResponse($response, ajaxConfig);
        } else {
          this.replaceHTML($response.firstChild);
        }
      })
      .catch(error => {
        this.ajaxFinished();
        console.error(error);
      });
  };

  replaceHTML = $response => {
    // replace innterHTML
    this.container.innerHTML = $response.innerHTML;

    this.checkForLoadMore();
    this.ajaxFinished();
  };

  handleConfigResponse = ($response, ajaxConfig) => {
    const configArray = JSON.parse(ajaxConfig);

    configArray.forEach(config => {
      const responseWrapper = $(config.container, $response);
      const domWrapper = $(config.container, this.container);

      if (responseWrapper && config.append) {
        // We want to append the children, not the container itself.
        const childrens = responseWrapper.children;

        if (childrens.length) {
          for (const item of childrens) {
            insertHTML(domWrapper, 'beforeend', item.outerHTML);
          }
        }
      } else {
        if (responseWrapper) {
          domWrapper.innerHTML = responseWrapper.innerHTML;
        } else {
          remove($(config.container, this.container));
        }
      }

      this.checkForLoadMore();
      this.ajaxFinished();
    });
  };

  checkForLoadMore = () => {
    // if response contains more load button, bind click event to it
    const loadMoreBtn = $('[data-ajax-onclick]', this.container);
    if (loadMoreBtn) {
      loadMoreBtn.addEventListener('click', e => {
        e.preventDefault();
        this.ajaxCall(
          loadMoreBtn.dataset.ajaxuri,
          loadMoreBtn.dataset.ajaxconfig
        );
      });
    }
  };

  init = () => {
    import(/* webpackChunkName: 'axios' */ 'axios').then(_ => {
      this.axios = _.default;
      if (this.ajaxUrl) {
        this.ajaxCall(this.ajaxUrl);
      } else {
        this.checkForLoadMore();
      }
    });
  };
}
